import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Gauge, TrendingUp, Zap, Clock, Cpu, Database } from 'lucide-react';

const PerformanceAnalytics = ({ healthData, metricsData }) => {
    const { t } = useLanguage();

    const PerformanceMetric = ({ icon: Icon, label, value, optimalRange, currentValue, unit = '' }) => {
        const isOptimal = currentValue >= optimalRange[0] && currentValue <= optimalRange[1];

        return (
            <div className="performance-metric">
                <div className="metric-header">
                    <Icon size={16} />
                    <span className="metric-label">{label}</span>
                    <div className={`metric-status ${isOptimal ? 'optimal' : 'suboptimal'}`}>
                        {isOptimal ? '✓' : '⚠'}
                    </div>
                </div>
                <div className="metric-value">
                    {value} {unit}
                </div>
                <div className="metric-range">
                    Optimal: {optimalRange[0]}{unit} - {optimalRange[1]}{unit}
                </div>
            </div>
        );
    };

    return (
        <div className="performance-analytics">
            <div className="analytics-header">
                <Gauge size={20} />
                <h3>{t('systemHealthPerformanceStats')}</h3>
            </div>

            <div className="performance-metrics">
                <PerformanceMetric
                    icon={Zap}
                    label={t('systemHealthQueryPerformance')}
                    value={metricsData?.queryPerformance || 0}
                    optimalRange={[80, 100]}
                    currentValue={metricsData?.queryPerformance || 0}
                    unit="%"
                />
                <PerformanceMetric
                    icon={Database}
                    label={t('systemHealthCacheEfficiency')}
                    value={metricsData?.bufferHitRatio || 0}
                    optimalRange={[90, 100]}
                    currentValue={metricsData?.bufferHitRatio || 0}
                    unit="%"
                />
                <PerformanceMetric
                    icon={TrendingUp}
                    label={t('systemHealthTransactionRate')}
                    value={metricsData?.transactionRate || 0}
                    optimalRange={[50, 100]}
                    currentValue={metricsData?.transactionRate || 0}
                    unit="/s"
                />
                <PerformanceMetric
                    icon={Clock}
                    label={t('systemHealthDiskIOLatency')}
                    value={metricsData?.diskLatency || 0}
                    optimalRange={[0, 5]}
                    currentValue={metricsData?.diskLatency || 0}
                    unit="ms"
                />
            </div>

            <div className="system-insights">
                <h4>{t('system_prediction_systemhealth')}</h4>
                <div className="insights-list">
                    {metricsData?.cpuUtilization > 70 && (
                        <div className="insight-item warning">
                            <Cpu size={14} />
                            <span>{t('high_cpu_usage_systemHealth')}</span>
                        </div>
                    )}
                    {metricsData?.memoryUsage > 80 && (
                        <div className="insight-item warning">
                            <Database size={14} />
                            <span>{t('memory_leak_detected_systemHealth')}</span>
                        </div>
                    )}
                    {healthData?.errors?.length > 0 && (
                        <div className="insight-item info">
                            <Gauge size={14} />
                            <span>{healthData.errors.length} {t('active_error_source_systemHealth')}</span>
                        </div>
                    )}
                    {(!healthData?.errors || healthData.errors.length === 0) && (
                        <div className="insight-item success">
                            <TrendingUp size={14} />
                            <span>{t('all_system_components_running_systemHealth')}</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PerformanceAnalytics;